module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px",
      "font-weight": "bold"
    }
  }, [_vm._v("macOS FAQ")]), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("1. 已安装了MOA但是后台提示未安装")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic01.png"),
      "width": "740px",
      "height": "400px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("原因：MOA安装后需要使用大象扫码登录后才算完全安装完毕。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决方法：请打开MOA客户端，使用大象扫码登陆。")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("2. macOS操作系统安装MOA时提示“打不开MOA安装包，因为它来自身份不明的开发者”")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic02.png"),
      "width": "640px",
      "height": "320px"
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决方法：在“系统偏好设置“-->”“安全性与隐私”-->\"通用\" 中找到阻止MOA打开的选项， 选择“仍然打开”。")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic03.png"),
      "width": "540px",
      "height": "400px"
    }
  })]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic04.png"),
      "width": "450px",
      "height": "400px"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("3. 应用打开页面空白")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic05.png"),
      "width": "650px",
      "height": "400px"
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决方法：")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("a、检查电脑的网络状况，待网络畅通后点击右上角“刷新页面”按钮刷新。")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("b、确认使用的MOA版本，使用最新稳定版MOA。（移步IT门户，确认或下载最新版MOA\n  "), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "data-pageid": "",
      "href": "https://itportal.sankuai.com/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("https://itportal.sankuai.com/")]), _vm._v("）\n  ")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("4.电脑网络正常但软件的客户端界面显示离线")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic06.png"),
      "width": "750px",
      "height": "400px"
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决方法：显示客户端离线是指软件与后台服务器的连接失败。此情况常见于电脑断网后的几分钟，软件会在十分钟之内重连服务器。")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("5.运行后“界面显示异常或空白”")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic07.jpg"),
      "width": "650px",
      "height": "400px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("原因：macOS 10.10版本的bug，不影响软件使用和统计，MOA新版本已修复。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决方法：")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("a.检查MOA是否最新版本，升级到最新版本；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("b.联系信息安全中心 ganlubing,zhaoliyang02。")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("6.首页网络接入处显示“无网络”")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic08.png"),
      "width": "750px",
      "height": "400px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("原因：macOS10.10的显示bug，不影响其他功能，可以忽略。显示在线就代表正常了，MOA新版本已修复。")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("7.阻断策略开启后，提示证书安装失败，需要手动输入密码")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("a、打开“钥匙串访问”app，打开方式：“启动台”-->“其他“-->”钥匙串访问“。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic10.png"),
      "width": "280px",
      "height": "220px"
    }
  })]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic11.png"),
      "width": "600px",
      "height": "220px"
    }
  })]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic12.png"),
      "width": "600px",
      "height": "300px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("b、选择菜单栏，“文件”-->\"锁定钥匙串'登陆'“。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic13.png"),
      "width": "580px",
      "height": "350px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("c、选择菜单栏，“文件” -->“解锁钥匙串'登陆'\"。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic14.png"),
      "width": "500px",
      "height": "390px"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("8.阻断策略开启后，无法登录SSO")])]), _vm._v(" "), _c('p', [_vm._v("打开系统“钥匙串访问”，搜索local，如图所示，查看证书“"), _c('strong', [_vm._v("localhost.moa.sankuai.com")]), _vm._v("”（下图红框标示）是否存在，")]), _vm._v(" "), _c('p', [_vm._v("若不存在，参考「9」中解决办法。")]), _vm._v(" "), _c('p', [_vm._v("若存在进一步抓取日记：切换到 ~/Library/Logs/itsec-agent/目录下。打开日期最近的一次日志，在日志中搜索\"SSLIdentityAndCertificates: Creating New Identity\"，如果搜索到关键字，")]), _vm._v(" "), _c('p', [_vm._v("解决方法参考「7」，如果没有，联系RD （信息安全中心：ganlubing,zhaoliyang02）")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic15.png"),
      "width": "850px",
      "height": "500px"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("9.阻断策略开启后，提示需要输入"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("本地管理员")]), _vm._v("密码弹框")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic16.png"),
      "width": "330px",
      "height": "150px"
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决方法：")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("1、需要输入的是"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("本地管理员密码")]), _vm._v("。")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("2、如果出现这种弹框，选择“始终允许”。")])]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("10.安装MOA后无法打开")])]), _vm._v(" "), _c('p', [_vm._v("如果MOA安装后无法打开，需确认macOS的操作系统版本，MOA的支持macOS版本为 >=10.11。如果您的操作系统是10.11,您需要安装最新版本的MOA，并"), _c('strong', [_vm._v("重启")]), _vm._v("您的操作系统。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("点击左上角苹果图标，查看「关于本机」显示操作系统版本")])]), _vm._v(" "), _c('p', [_vm._v("如果操作系统版本满足要求，还有问题，联系RD（信息安全中心：ganlubing,zhaoliyang02）")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("11、查看MOA版本")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic17.png"),
      "width": "1000px",
      "height": "600px"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("12、MOA扫码后账户显示“unknow”")])]), _vm._v(" "), _c('p', [_vm._v("旧版本MOA未彻底卸载，MOA新版本运行异常。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic18.png"),
      "width": "200px",
      "height": "200px"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("请在终端中执行：rm -rf /Applications/MOA.app ，删除掉旧版本MOA残留文件后，重新安装最新版MOA，即可扫码成功。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/macOS_FAQ/macOS_FAQ_pic19.png"),
      "width": "900px",
      "height": "150px"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("13、MOA已经是最新版本，仍然跳出拦截。")])]), _vm._v(" "), _c('p', [_vm._v("旧版本MOA未彻底卸载，MOA新版本运行异常。")]), _vm._v(" "), _c('p', [_vm._v("解决方法：请在终端中执行： rm -rf /Applications/MOA.app 后，删除掉旧版本MOA残留文件后，重新安装最新版MOA。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d9a7a356!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/macOS_FAQ.vue
// module id = 657
// module chunks = 1